export default {
      id: "icon-trans-genre-usage",
      viewBox: "0 0 113.4 132",
      url: __webpack_public_path__ + "icons.svg#icon-trans-genre",
      toString: function () {
        return this.url;
      }
    }